var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeactivatedShieldIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.162,
    height: 42.028,
    viewBox: "0 0 39.162 50.028",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "verified_user_24dp_5F6368_FILL0_wght200_GRAD0_opsz24",
    d: "M216.644-803.966l13.868-13.868-2-2-11.872,11.872-5.982-5.982-2,2Zm2.937,17.074A26.226,26.226,0,0,1,205.576-797.1,28.926,28.926,0,0,1,200-814.477V-829.6l19.581-7.316,19.581,7.316v15.127a28.926,28.926,0,0,1-5.576,17.373A26.226,26.226,0,0,1,219.581-786.892Zm0-2.969a22.764,22.764,0,0,0,12.028-9.231,26.568,26.568,0,0,0,4.755-15.385v-13.217l-16.784-6.24-16.784,6.24v13.217a26.568,26.568,0,0,0,4.755,15.385A22.764,22.764,0,0,0,219.581-789.861ZM219.581-811.906Z",
    transform: "translate(-200 836.92)",
    fill: "#A5A5A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivatedShieldIcon);
export default __webpack_public_path__ + "static/media/deactivated_shield_icon.f13ccacf50c847345896e53584e05519.svg";
export { ForwardRef as ReactComponent };